import React from "react";
import Navbar from "../components/Home/Navbar";
import Footer from "../components/Home/Footer"; // Added Footer Import
import { Phone, Mail, MapPin, Heart, Send } from "lucide-react";

const DonationContact = () => {
  const contactDetails = {
    address:
      "Chandippa Village, Shankarpalli Mandal, Ranga Reddy Dist, Telangana, India-501203",
    phones: ["+91 76808 79388", "+91 96669 59911"],
    email: "srimarakathashivalingam@gmail.com",
  };

  return (
    <div className="min-h-screen bg-orange-50 font-sans text-stone-900">
      <Navbar />

      {/* Header Section */}
      <section className="bg-orange-600 text-white py-16 px-4 text-center relative overflow-hidden">
        <div className="absolute inset-0 opacity-10 pointer-events-none flex justify-center items-center">
          <span className="text-[20rem] font-serif">ॐ</span>
        </div>
        <div className="relative z-10">
          <Heart className="mx-auto mb-4 text-orange-200" size={40} />
          <h1 className="text-4xl md:text-5xl font-serif font-bold mb-4">
            Contact & Reach Us
          </h1>
          <p className="text-orange-100 text-lg max-w-2xl mx-auto">
            Connect with us for Seva details, Pooja timings, or directions to
            the temple.
          </p>
        </div>
      </section>

      {/* Main Content Area */}
      <main className="max-w-4xl mx-auto px-4 -mt-10 mb-20 relative z-10">
        <div className="bg-white p-8 md:p-12 rounded-[2rem] shadow-xl border-t-8 border-orange-500">
          <div className="flex items-center gap-3 text-orange-600 mb-10 justify-center">
            <Send size={28} />
            <h2 className="text-3xl font-serif font-bold text-stone-800">
              Devasthanam Information
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {/* Left: Address & Email */}
            <div className="space-y-8">
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-orange-100 text-orange-600 rounded-2xl flex items-center justify-center shrink-0">
                  <MapPin size={24} />
                </div>
                <div>
                  <h4 className="text-xs font-black text-stone-400 uppercase tracking-widest mb-1">
                    Location
                  </h4>
                  <p className="text-stone-700 font-semibold leading-relaxed">
                    {contactDetails.address}
                  </p>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 bg-orange-100 text-orange-600 rounded-2xl flex items-center justify-center shrink-0">
                  <Mail size={24} />
                </div>
                <div className="min-w-0">
                  {" "}
                  {/* Added min-w-0 to allow container to shrink */}
                  <h4 className="text-xs font-black text-stone-400 uppercase tracking-widest mb-1">
                    Email Support
                  </h4>
                  <p className="text-stone-700 font-bold break-all">
                    {" "}
                    {/* Added break-all here */}
                    {contactDetails.email}
                  </p>
                </div>
              </div>
            </div>

            {/* Right: Phone Numbers */}
            <div className="bg-orange-50 p-8 rounded-3xl border border-orange-100 flex flex-col justify-center">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-orange-600 text-white rounded-full flex items-center justify-center">
                  <Phone size={20} />
                </div>
                <h4 className="text-sm font-black text-orange-900 uppercase tracking-widest">
                  Phone Numbers
                </h4>
              </div>
              <div className="space-y-2">
                {contactDetails.phones.map((p, i) => (
                  <p
                    key={i}
                    className="text-stone-800 font-black text-2xl tracking-tight"
                  >
                    {p}
                  </p>
                ))}
              </div>
            </div>
          </div>

          {/* Map Button */}
          <div className="mt-12 text-center">
            <button
              className="w-full md:w-auto bg-stone-900 text-white px-12 py-5 rounded-2xl font-bold hover:bg-stone-800 transition-all shadow-2xl shadow-stone-300 flex items-center justify-center gap-3 mx-auto active:scale-95"
              onClick={() =>
                window.open(
                  "https://www.google.com/maps/place/Chandippa+Marakatha+Shiva+Temple/@17.4450792,78.1093252,17z/data=!3m1!4b1!4m6!3m5!1s0x3bcbef7cfd72586d:0x8727fe5156723643!8m2!3d17.4450792!4d78.1119001!16s%2Fg%2F1hc2gsntv?entry=ttu&g_ep=EgoyMDI2MDEwNy4wIKXMDSoASAFQAw%3D%3D",
                  "_blank"
                )
              }
            >
              <MapPin size={24} className="text-orange-500" />
              Navigate in Google Maps
            </button>
            <p className="mt-4 text-xs text-stone-400 font-medium italic">
              Click the button above to view the exact temple location on Google
              Maps.
            </p>
          </div>
        </div>
      </main>

      {/* Footer component integrated here */}
      <Footer />
    </div>
  );
};

export default DonationContact;
